export default {"src":"/_next/static/media/ic-sad.e5997162.svg","height":148,"width":148,"blurWidth":0,"blurHeight":0};